import { API_ENDPOINTS } from '../constants/api-endpoints';
import { API } from './api-config';

const { CERTIFICATE } = API_ENDPOINTS;
const { FIND_FILE } = CERTIFICATE;

export const ApiCertificate = {
  findFile: (uid: string | number) => {
    return API({
      path: FIND_FILE,
      method: 'GET',
      pathParams: { uid },
    });
  },
};
